import React from "react";

const BlogSlider = () => {
const blogs = [
  {
    image: "/images/keyword/2.jpg",
    date: "14 Jun, 2026",
    title: "Pune to Bhimashankar Cab",
    url: "/Pune-to-Bhimashankar-Cab",
    description:
      "Travel from Pune to Bhimashankar in comfort with safe, reliable, and affordable taxi services for pilgrims and tourists.",
  },
  {
    image: "/images/keyword/34.jpg",
    date: "14 Jun, 2026",
    title: "Pune to Mumbai Airport Cab",
    url: "/Pune-to-Mumbai-Airport-Cab",
    description:
      "Enjoy timely airport transfers between Pune and Mumbai Airport with professional drivers and convenient pickup options.",
  },
  {
    image: "/images/keyword/38.jpg",
    date: "14 Jun, 2026",
    title: "Pune to Kolhapur Cab",
    url: "/Pune-to-Kolhapur-Cab",
    description:
      "Experience a smooth Pune to Kolhapur journey with well-maintained cabs, transparent pricing, and doorstep service.",
  },
   
  ];

  return (
    <section
      className="text-center"
      id="blog-sec"
      style={{
        background: "#f8fafc",
      }}
    >
      <div className="container">
        {/* Section Heading */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <div className="title-area">
              
              <span
                style={{
                  color: "#F26722",
                  fontWeight: "700",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                Rising Cab Service Blog
              </span>

              <h2
                className="sec-title text-center"
                style={{
                  color: "#0A2A66",
                  marginTop: "10px",
                }}
              >
                Travel Guides & Cab Booking Tips
              </h2>

              {/* <p className="sec-text">
                Discover travel guides, airport transfers,
                outstation cab services, pilgrimage tours and
                vehicle rental solutions from Rising Cab Service.
              </p> */}
            </div>
          </div>
        </div>

        {/* Blog Cards */}
        <div className="row">
          {blogs.map((blog, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-4 col-md-6 mb-4  "
            >
              <div
               className="borderr"
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  // height: "100%",
                  transition: "0.3s ease",
                }}
              >
                <div className="blog-img">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    style={{
                      width: "100%",
                      height: "240px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div style={{ padding: "25px" }}
                
                >
                  
                  {/* <span
                    style={{
                      color: "#F26722",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {blog.date}
                  </span> */}

                  <h3
                 
                    style={{
                      color: "#0A2A66",
                      fontWeight: "700",
                      fontSize: "22px",
                      marginTop: "10px",
                      // minHeight: "65px",
                    }}
                  >
                    {blog.title}
                  </h3>

                  <p
                    style={{
                      color: "#666",
                      marginBottom: "20px",
                    }}
                  >
                    {blog.description}
                  </p>

                  <a
                    href={blog.url}
                    className="text-center"
                    style={{
                      background: "#F26722",
                      color: "#fff",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      textDecoration: "none",
                      fontWeight: "600",
                      display: "inline-block",
                    }}
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BlogSlider;